import { usePowerBiReportWithToken } from './queries/reports/use-power-bi-report-with-token'
import {
  ReportType,
  reportTypes,
  usePowerBiReportsByType,
} from './queries/reports/use-power-bi-reports-by-type'

export function usePowerBiReport(reportType: string | undefined) {
  const isValidReportType = reportTypes.some(
    (type) => type.toLowerCase() === reportType?.toLowerCase(),
  )

  const validatedReportType = isValidReportType
    ? (reportType as ReportType)
    : undefined

  const {
    data: reports,
    isLoading: isLoadingReports,
    isError: isErrorReports,
  } = usePowerBiReportsByType(validatedReportType)

  const selectedReport = reports ? reports[0] : undefined
  const {
    data: report,
    isLoading: isLoadingReport,
    isError: isErrorReport,
  } = usePowerBiReportWithToken(selectedReport?.id)

  return {
    data: report,
    isLoading: isLoadingReports || isLoadingReport,
    isError:
      isErrorReports ||
      isErrorReport ||
      (!isLoadingReports && !selectedReport?.id),
  }
}
